import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Loader, Text, TextInput, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';
import Grid from "@mui/material/Grid";
import Header from '../../components/Header.js';
import PredeterminationBlock from './components/PredeterminationBlock.js';
import { getPredeterminations } from '../../actions/adjudication.js';
import permissionLevel from '../../services/permissions.js';

class Predeterminations extends PureComponent {
    state = {
        benefit: null,
        query: null
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Adjudication', props.master.access).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        if (!this.props.predeterminations) {
            this._getPredeterminations(0);
        }
    }

    _handleInputChange = async (type, value) => {
        if ((value === 'All' || value === 'Submission Date')) {
            value = null;
        }

        await this.setState({
            [type]: value
        });

        if (type !== 'query') {
            this._getPredeterminations(0);
        }
    };

    _handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this._getPredeterminations(0);
        }

        return false;
    };

    _getPredeterminations = (cursor = false) => {
        this.props.dispatch(getPredeterminations(this.state, cursor));
    };

    render() {
        if (!this.props.predeterminations || this.props.master.loading) {
            return <Loader isContainer/>;
        }

        return (
            <ContainerControlSite onKeyPress={ (e) => this._handleKeyPress(e) }>
                <Header
                    subHeader="Predeterminations"
                    breadcrumbs={[
                        {
                            title: 'Adjudication',
                            link: `/adjudication`
                        }
                    ]}
                    selectedTitle="adjudication"
                />

                <Content>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{
                            marginBottom: 20
                        }}
                    >
                        <Grid item xs={12} md={6} lg={8} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Search By Certificate #"
                                fullWidth
                                value={ this.state.query || '' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("query", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Benefit"
                                fullWidth
                                value={ this.state.benefit || 'All' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("benefit", e.target.value)}
                                select
                                selectOptions={[
                                    'All',
                                    'Dental',
                                    'Paramedicals',
                                    'Health',
                                    'Vision'
                                ]}
                            />
                        </Grid>
                    </Grid>

                    <PredeterminationBlock isHeader access={ this.props.master.access } />

                    {
                        this.props.predeterminations.map((predetermination) => (
                            <PredeterminationBlock
                                key={predetermination.predeterminationID}
                                predeterminationID={predetermination.predeterminationID}
                                referenceNumber={predetermination.referenceNumber}
                                user={predetermination.name}
                                submitted={Number(predetermination.amountSubmitted)}
                                adjudicated={Number(predetermination.adjudicatedAmount)}
                                claimed={Number(predetermination.amountPaid)}
                                submissionDate={ predetermination.dateAdded }
                                benefit={predetermination.benefit}
                                isAdjudicationList={true}
                                access={ this.props.master.access }
                            />
                        ))
                    }

                    {
                        this.props.predeterminations.length === 0 &&
                            <Text
                                align="center"
                                mediumLarge
                                display="block"
                            >
                                No predeterminations to display
                            </Text>
                    }

                    {
                        this.props.predeterminations.length > 0 && this.props.cursor >= 0 &&
                            <Button
                                onClick={() => this._getPredeterminations(false)}
                                color="primary"
                                marginTop={2.5}
                                fullWidth
                            >
                                Load More
                            </Button>
                    }
                </Content>
                <span id="adjudication" />
            </ContainerControlSite>
        );
    }
}

Predeterminations.propTypes = {
    claims: PropTypes.array,
    cursor: PropTypes.number,
    master: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    masterLoading: state.master.loading,
    predeterminations: state.adjudication.predeterminations,
    cursor: state.adjudication.predeterminationsCursor,
    master: state.master
});

export default connect(mapStateToProps)(Predeterminations);